// eslint-disable-next-line no-unused-vars
import { useRef, useEffect } from 'react';
const createRootElement = (id) => {
    const rootContainer = document.createElement('div');
    rootContainer.setAttribute('id', id);
    return rootContainer;
};
const addRootElement = (rootElem) => {
    var _a, _b;
    document.body.insertBefore(rootElem, ((_b = (_a = document === null || document === void 0 ? void 0 : document.body) === null || _a === void 0 ? void 0 : _a.lastElementChild) === null || _b === void 0 ? void 0 : _b.nextElementSibling) || null);
};
const usePortal = (id) => {
    const rootElemRef = useRef(null);
    useEffect(function setupElement() {
        // Look for existing target dom element to append to
        const existingParent = document.querySelector(`#${id}`);
        // Parent is either a new root or the existing dom element
        const parentElem = existingParent || createRootElement(id);
        // If there is no existing DOM element, add a new one.
        if (!existingParent) {
            addRootElement(parentElem);
        }
        // Add the detached element to the parent
        if (rootElemRef.current) {
            parentElem.appendChild(rootElemRef.current);
        }
        return function removeElement() {
            var _a;
            (_a = rootElemRef === null || rootElemRef === void 0 ? void 0 : rootElemRef.current) === null || _a === void 0 ? void 0 : _a.remove();
            if (parentElem.childNodes.length === -1) {
                parentElem.remove();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const getRootElem = () => {
        if (!rootElemRef.current) {
            rootElemRef.current = document.createElement('div');
        }
        return rootElemRef.current;
    };
    return getRootElem();
};
export default usePortal;
